// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-0Z0","clinicsSelect":"styles_clinicsSelect__3dgQT"};